import { Component, Inject } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { Notification } from 'src/app/models/domain';
import { MaintenanceManagementSystemHistoryService, PagedCollection } from 'src/app/state';
import { EquipmentLookupService } from 'src/app/state/equipment/equipment-lookup.service';
import { HISTORY_PAGINATOR } from './history-details-pagination.provider';

@Component({
  selector: 'em-history-details',
  templateUrl: './history-details.component.html',
  standalone: false,
})
export class HistoryDetailsComponent {
  public error$ = this.historyService.error$;

  public loading$ = combineLatest([
    this.paginationRef.loading$,
    this.equipmentLookup.loading$,
  ]).pipe(map(([historyLoading, equipmentLoading]) => historyLoading || equipmentLoading));

  public activeEquipmentNumber$ = this.equipmentLookup.selectedEquipmentId$;
  public perPage$ = new BehaviorSubject<number>(1);
  public page$ = this.paginationRef.pageChanges;

  public shouldClearCacheWhenChanged$ = combineLatest([
    this.activeEquipmentNumber$,
    this.perPage$,
  ]).pipe(
    tap(() => {
      this.paginationRef.clearCache();
    })
  );

  public pagination$ = combineLatest([this.page$, this.shouldClearCacheWhenChanged$]).pipe(
    switchMap(([page, [equipmentNumber, perPage]]) =>
      this.paginationRef.getPage(() =>
        this.historyService.loadHistoryPage({ page, perPage }, equipmentNumber ?? undefined)
      )
    )
  );

  public perPage = 1;
  public page = 1;

  public readonly trackByRef = trackByRef;

  public constructor(
    private readonly historyService: MaintenanceManagementSystemHistoryService,
    private readonly equipmentLookup: EquipmentLookupService,
    @Inject(HISTORY_PAGINATOR) public paginationRef: PagedCollection<Notification>
  ) {}

  public pageSizeChange(perPage: number) {
    this.perPage$.next(perPage);
  }
}
